import { render } from "./VideoGeneric.vue?vue&type=template&id=174be5b7"
import script from "./VideoGeneric.vue?vue&type=script&lang=js"
export * from "./VideoGeneric.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Proyectos\\puerto-antioquia-web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__